import cn from "classnames";
import React, { ReactElement, ReactNode, useRef, useState } from "react";

import { IPopoverProps } from "./PopoverOverlay";
import { Placement, Popover2, Popover2InteractionKind } from "@blueprintjs/popover2";
import "@blueprintjs/popover2/lib/css/blueprint-popover2.css";

import styles from "./PopoverOverlay.module.scss";

export interface IProps extends IPopoverProps {
  calculatePlacement?: (offsetFromBottom: number) => IPopoverProps["placement"];
}

export const PopoverOverlayWithRealigning = React.forwardRef<HTMLElement, IProps>(
  (
    {
      isOpen,
      onClose,
      onInteraction,
      placement = "auto",
      children,
      content,
      className,
      popoverBorderColor = "default",
      popoverClassName,
      isDisabled = false,
      openType = "click",
      onOpen,
      portalClassName,
      isMinimal,
      modifiers,
      usePortal = true,
      portalContainer,
      calculatePlacement,
    },
    ref
  ) => {
    const onOpened = (popoverElement: HTMLElement) => {
      onOpen?.();
      // Специальные значения проставляются через классы
      if (
        popoverBorderColor &&
        popoverElement &&
        popoverBorderColor !== "default" &&
        popoverBorderColor !== "primary"
      ) {
        // Граница попапа
        popoverElement.style.borderColor = popoverBorderColor;
        // Цвет границы стрелки
        popoverElement.style.fill = popoverBorderColor;
      }
    };

    const defaultPlacement = placement;
    const [actualPlacement, setActualPlacement] = useState<IPopoverProps["placement"]>(defaultPlacement);

    return (
      <Popover2
        //key={actualPlacement}
        onClose={onClose}
        popoverRef={ref}
        isOpen={isOpen}
        usePortal={usePortal}
        onInteraction={onInteraction}
        content={content}
        placement={actualPlacement}
        disabled={isDisabled}
        interactionKind={openType}
        rootBoundary={"viewport"}
        portalContainer={portalContainer}
        className={className}
        popoverClassName={cn(
          styles.popover,
          {
            [styles.borderPrimary]: popoverBorderColor === "primary",
            [styles.borderDefault]: popoverBorderColor === "default",
          },
          popoverClassName
        )}
        portalClassName={cn(styles.portal, portalClassName)}
        onOpened={onOpened}
        hoverOpenDelay={0}
        hoverCloseDelay={0}
        transitionDuration={0}
        enforceFocus={false}
        minimal={isMinimal}
        modifiers={modifiers}
      >
        <div
          onMouseEnter={(e) => {
            const rect = (e.target as HTMLDivElement).getBoundingClientRect();
            const distanceToBottom = window.innerHeight - rect.bottom;
            if (calculatePlacement) {
              setActualPlacement(calculatePlacement(distanceToBottom));
            }
          }}
        >
          {children}
        </div>
      </Popover2>
    );
  }
);
